module.exports = __webpack_public_path__ + "img/p2-51.8233a150.png";